import { FC } from 'react';
import { LineItem } from 'shared/types/cart/LineItem';
import useClassNames from 'helpers/hooks/useClassNames';
import { ImageProps } from 'frontastic/lib/image';
import OrderItem from './order-item';

type OrderItemsListProps = {
  className?: string;
  lineItems: LineItem[];
  productLogo?: ImageProps;
};

const OrderItemsList: FC<OrderItemsListProps> = ({ lineItems, className, productLogo }) => {
  const containerClassName = useClassNames([
    'grid max-h-316 w-full grid-cols-1 divide-y divide-neutral-400 overflow-auto',
    className,
  ]);

  return (
    <div className={containerClassName}>
      {lineItems.map((lineItem) => (
        <OrderItem key={lineItem.lineItemId} lineItem={lineItem} productLogo={productLogo} />
      ))}
    </div>
  );
};

export default OrderItemsList;
